import { render, staticRenderFns } from "./CreateFormDate.vue?vue&type=template&id=5a267875&"
import script from "./CreateFormDate.vue?vue&type=script&lang=js&"
export * from "./CreateFormDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports